'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/syntax.js
// module id = 548
// module chunks = 0